import { render, staticRenderFns } from "./SectorReturns.vue?vue&type=template&id=03ce5f1b&"
import script from "./SectorReturns.vue?vue&type=script&lang=js&"
export * from "./SectorReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports